<script>
    export let enabled;

    let enabledBoolean

    enabledBoolean = enabled === "true";

</script>

<div class="container">
    {#if (enabledBoolean)}
        Enabled
    {:else}
        Disabled
    {/if}
    <div class="slider-holder">
        <label class="switch">
            <input type="checkbox" bind:checked={enabledBoolean}>
            <span class="slider round"></span>
        </label>
    </div>
</div>

<style>
    .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .slider-holder {
        flex-grow: 1;
        justify-content: center;
    }

    label {
        position: relative;
        display: inline-block;
        width: 44px;
        height: 24px;
    }

    input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 20px;
        width: 20px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        transition: .2s;
    }

    input:checked + .slider {
        background-color: var(--dark-background);
    }

    input:focus + .slider {
        box-shadow: 0 0 1px var(--dark-background);
    }

    input:checked + .slider:before {
        transform: translateX(20px);
    }

    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

</style>
